import { z } from 'zod'
import { stringSchema } from './common'

const giftCardUsageSchema = z.object({
  id: stringSchema.nullish(),
  createdAt: stringSchema.nullish(),
  amount: z.coerce.number().nullish(),
  balance: z.coerce.number().nullish(),
  description: stringSchema.nullish(),
  orderNumber: stringSchema.nullish(),
})

export const giftCardPurchaseInputSchema = z.object({
  code: stringSchema.min(1),
  amount: z.coerce.number().positive().nullish(),
})

const giftCardCurrencySchema = z.object({
  id: stringSchema.min(1).nullish(),
  code: stringSchema.min(1),
  sign: stringSchema.min(1).nullish(),
  precision: z.coerce.number().int().min(0).nullish(),
})

export const giftCardConfigSchema = z.object({
  productId: stringSchema.min(1),
  type: stringSchema.min(1),
  currency: giftCardCurrencySchema,
  presetValues: z.array(z.coerce.number()).default([]),
  minValue: z.coerce.number().nullish(),
  maxValue: z.coerce.number().nullish(),
})

export const giftCardLookupSchema = z.object({
  currency: z.object({ code: stringSchema.regex(/^[A-Z]{3}$/), precision: z.coerce.number() }),
  code: stringSchema.min(1),
  status: stringSchema.min(1),
  expiryDate: stringSchema.nullish(),
  originalValue: z.coerce.number().nullish(),
  currentValue: z.coerce.number().nullish(),
  usageHistory: z.array(giftCardUsageSchema).default([]),
})

export const giftCardCartDetailsSchema = z.object({
  value: z.coerce.number().nullish(),
  recipientName: stringSchema.nullish(),
  recipientEmail: stringSchema.nullish(),
  message: stringSchema.nullish(),
})

export type GiftCardConfig = z.infer<typeof giftCardConfigSchema>
export type GiftCardLookup = z.infer<typeof giftCardLookupSchema>
export type GiftCardPurchaseInput = z.infer<typeof giftCardPurchaseInputSchema>
export type GiftCardCartDetails = z.infer<typeof giftCardCartDetailsSchema>
